var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDchvkhost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8441,
    cy: 27.2279,
    r: 26.4623,
    fill: "#FA5A7D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8441,
    cy: 27.2123,
    r: 26.4623,
    fill: "#FA5A7D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8435 16.3203V38.1128M15.9473 27.2165H37.7397",
    stroke: "white",
    strokeWidth: 4.66981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDchvkhost);
export default __webpack_public_path__ + "static/media/dịch vụ khảo sát.7b4a5c9461c5fcb05d587477c4847518.svg";
export { ForwardRef as ReactComponent };